import * as React from 'react';

const AccordionContext = React.createContext({});

export default AccordionContext;